var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.675 0H1.324C.593 0 0 .593 0 1.325v21.351C0 23.408.593 24 1.325 24h21.35c.732 0 1.325-.593 1.325-1.324V1.323C24 .593 23.407 0 22.675 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4267B2",
    d: "M16.601 24v-9.244h3.12l.467-3.618H16.6V8.834c0-1.045.29-1.757 1.79-1.757h1.902V3.849c-.331-.044-1.466-.142-2.786-.142-2.757 0-4.644 1.68-4.644 4.768v2.663H9.756v3.618h3.107V24h3.738Z"
  })));
};
export default SvgFacebook;